var _defs, _circle, _circle2, _g, _circle3, _circle4, _path, _polygon, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKuzel5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ring",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#e6ebf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#9aa6b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6c7787"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "face",
    cx: 0.35,
    cy: 0.28,
    r: 0.85
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f8fafc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#dde3ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gloss",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#ffffff",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffffff",
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 97,
    fill: "url(#ring)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 97,
    fill: "none",
    stroke: "#6c7787",
    strokeWidth: 2.5,
    opacity: 0.55
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e6ebf2",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 186.3,
    cy: 117.2,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.2,
    cy: 148.9,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.9,
    cy: 173.2,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.2,
    cy: 186.3,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8,
    cy: 186.3,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.1,
    cy: 173.2,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.8,
    cy: 148.9,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.7,
    cy: 117.2,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.7,
    cy: 82.8,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.8,
    cy: 51.1,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.1,
    cy: 26.8,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8,
    cy: 13.7,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.2,
    cy: 13.7,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.9,
    cy: 26.8,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.2,
    cy: 51.1,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.3,
    cy: 82.8,
    r: 3.1
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 79,
    fill: "url(#face)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 79,
    fill: "none",
    stroke: "#6c7787",
    strokeWidth: 2,
    opacity: 0.45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 21 100 A 79 79 0 0 1 179 100 Z",
    fill: "url(#gloss)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "100.0,37.5 102.2,42.9 108.1,43.4 103.6,47.2 105.0,52.9 100.0,49.8 95.0,52.9 96.4,47.2 91.9,43.4 97.8,42.9",
    fill: "#6c7787",
    stroke: "#e6ebf2",
    strokeWidth: 1.2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100,100) scale(0.86)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 31,
    rx: 43,
    ry: 9.5,
    fill: "#c05f00"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 29,
    rx: 43,
    ry: 9.5,
    fill: "#e07f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -34 29 L -8.5 -46 Q 0 -52.5 8.5 -46 L 34 29 Z",
    fill: "#ff9911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 -50.6 L 8.5 -46 L 34 29 L 0 29 Z",
    fill: "#e07f00",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -21.7 -6 L 21.7 -6 L 26.5 8 L -26.5 8 Z",
    fill: "#f4f4f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 -6 L 21.7 -6 L 26.5 8 L 0 8 Z",
    fill: "#d9d9de",
    opacity: 0.55
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 136,
    width: 46,
    height: 38,
    rx: 19,
    fill: "#6c7787",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 138,
    width: 42,
    height: 34,
    rx: 17,
    fill: "none",
    stroke: "#e6ebf2",
    strokeWidth: 1.6,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 165,
    textAnchor: "middle",
    fontFamily: "Arial Black, Arial, Helvetica, sans-serif",
    fontSize: 30,
    fontWeight: "bold",
    fill: "#ffffff",
    letterSpacing: 0.5
  }, "5"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuzel5);
export default __webpack_public_path__ + "static/media/kuzel-5.de9183bdfb48d4ad3f6fc9fd52ce3b21.svg";
export { ForwardRef as ReactComponent };